import React, { useState, useEffect } from "react";

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: React.ReactNode;
}

const SafeImage = ({ src, alt, fallback = null, ...props }: SafeImageProps): JSX.Element | null => {
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (!src) {
      setIsValid(false);
      return;
    }

    const img = new Image();
    img.src = src;

    img.onload = () => setIsValid(true);
    img.onerror = () => setIsValid(false);
  }, [src]);

  if (!isValid) return fallback ? <>{fallback}</> : null;

  return <img src={src} alt={alt} {...props} />;
};

export default SafeImage;
